exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.quantity {\n  height: 37px;\n  line-height: 37px;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/xampp_bk/htdocs/xampp/organicshop/src/app/shared/components/product-quantity/product-quantity.component.css
// module id = ../../../../../src/app/shared/components/product-quantity/product-quantity.component.css
// module chunks = 1